import { BsDash, BsGlobe2, BsServer } from 'react-icons/bs';
import { AiFillHtml5, AiFillGithub } from 'react-icons/ai';
import cv from "../../assets/cv.pdf"
import Zoom from 'react-reveal/Zoom';
import Fade from 'react-reveal/Fade';

const SkillsComponent = () => {
    return (
        <div className="h-full bg-primary px-[30px] flex flex-col-reverse md:flex-row py-[150px] gap-[60px] md:gap-[30px] lg:gap-0 ">
            <div className="md:basis-[60%] lg:basis-[40%]">
                <div className='w-full h-full flex flex-col text-white gap-[40px] '>
                    <div className='md:basis-[35%] lg:basis-[50%] gap-[60px] md:gap-[30px] flex flex-col md:flex-row '>
                        <Zoom>
                            <div className='skills-box'>
                                <div className='circle '>
                                    <BsGlobe2 />
                                </div>
                                <h1 className='text-[20px] lg:text-[28px] font-[600] text-center font-montserrat'>Web Dev.</h1>
                                <p className='text-ash text-[14px] lg:text-[18px] font-poppins text-center'>Building Websites and Applications for the internet</p>
                            </div>
                        </Zoom>
                        <Zoom delay={300}>
                            <div className='skills-box relative md:bottom-[-40px]'>
                                <div className='circle '>
                                    <AiFillHtml5 />
                                </div>
                                <h1 className='text-[20px] lg:text-[28px] font-[600] text-center font-montserrat'>Front-End Dev.</h1>
                                <p className='text-ash  text-[14px] lg:text-[18px] font-poppins text-center'>Architects and Develops Websites and Applications using Web Technologies</p>
                            </div>
                        </Zoom>
                    </div>
                    <div className='md:basis-[35%] lg:basis-[50%] gap-[60px] md:gap-[30px] flex flex-col md:flex-row'>
                        <Zoom>
                            <div className='skills-box'>
                                <div className='circle '>
                                    <AiFillGithub />
                                </div>
                                <h1 className='text-[20px] lg:text-[28px] font-[600] text-center font-montserrat'>GitHub</h1>
                                <p className='text-ash text-[14px] lg:text-[18px] font-poppins text-center'> Storing, Tracking, and Collaborating on Software Projects</p>
                            </div>
                        </Zoom>
                        <Zoom delay={300}>
                            <div className='skills-box relative md:bottom-[-40px]'>
                                <div className='circle '>
                                    <BsServer />
                                </div>
                                <h1 className='text-[20px] lg:text-[28px] font-[600] text-center font-montserrat'>Back-End Dev.</h1>
                                <p className='text-ash text-[14px] lg:text-[18px] font-poppins text-center'>Databases, Back-end Logic, APIs, Architecture, and Servers.</p>
                            </div>
                        </Zoom>
                    </div>
                </div>
            </div>
            <div className="md:basis-[40%]  lg:basis-[60%] text-white lg:pl-[100px]  lg:mt-[90px]">
                <p className='flex text-accent items-center text-[16px] font-poppins'><BsDash /> My Skills</p>
                <Fade bottom delay={300}>
                    <div>
                        <h1 className='mt-2 font-montserrat text-[25px] lg:text-[38px] font-[650] lg:font-[600] leading-[2rem] md:leading-[3rem]'>Why Hire Me For Next Project?</h1>
                        <p className='text:[14px] lg:text-[18px] font-poppins mt-2 lg:mt-8 font-[350] md:tracking-[0.05em] text-ash'>Experienced Full Stack Developer adept in all stages of advanced web development. Knowledgeable in user interface, testing, and debugging processes. Proficient in an assortment of technologies, including Basic design languages like HTML and CSS and CSS pre-processors like SASS. Armed with knowledge in programming languages like C#, JavaScript and Typescript. I can develop a great UI/UX on the front-end with massive functionalities with vanilla JavaScript or libraries like React and work with application development software like Firebase or with a full-fledged back-end service developed with .Net  connecting to relational databases like MsSQL and SQLServer  or NoSQL databases like MongoDB containerized with Docker and shipped to cloud infrastructures like Google Cloud Platform or DigitalOcean with ability to effectively self-manage during independent projects, as well as collaborate in a team setting.</p>
                    </div>
                </Fade>
                <Fade bottom delay={600}>
                    <a href={process.env.REACT_APP_CV_URL} download="mazstar cv" target='_blank' className="w-full md:w-[200px] h-[60px] flex justify-center items-center mt-8 text-primary rounded-[14px] font-montserrat text-[16px] font-[500] cursor-pointer bg-[transparent] bg-gradient-to-r from-secondary to-text  hover:bg-gradient-to-l transition-all duration-[1000ms] whitespace-nowrap shadow-text"
                    >Download CV</a>
                </Fade>

            </div>
        </div>
    );
}

export default SkillsComponent;